// Referral API helpers + cookie/localStorage attribution

import { api } from "./api";

const REF_KEY = "sat_ref";
const REF_TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export const captureRefFromUrl = async () => {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  const code = params.get("ref");
  if (!code) return getStoredRef();
  // Validate & store
  try {
    const r = await api.post("/referrals/track", { code });
    const payload = { code, ts: Date.now() };
    window.localStorage.setItem(REF_KEY, JSON.stringify(payload));
    return { ...payload, referrer: r.data.referrer };
  } catch (_) { return null; }
};

export const getStoredRef = () => {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(REF_KEY);
    if (!raw) return null;
    const { code, ts } = JSON.parse(raw);
    if (!code || Date.now() - ts > REF_TTL_MS) { window.localStorage.removeItem(REF_KEY); return null; }
    return { code, ts };
  } catch (_) { return null; }
};

export const fetchMyReferrals = () => api.get("/referrals/me").then(r => r.data);
export const adminListCommissions = () => api.get("/admin/commissions").then(r => r.data);
export const adminPayout = (commission_id) => api.post("/admin/commissions/payout", { commission_id }).then(r => r.data);
